module.exports = __webpack_public_path__ + "assets/43dfebb474b95b80e2bbeef797081ae0.gif";